export default "__VITE_PUBLIC_ASSET__9b5e68f1__"